import { render, staticRenderFns } from "./organization-members.vue?vue&type=template&id=15cd6c74&scoped=true"
import script from "./organization-members.vue?vue&type=script&lang=js"
export * from "./organization-members.vue?vue&type=script&lang=js"
import style0 from "./organization-members.vue?vue&type=style&index=0&id=15cd6c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cd6c74",
  null
  
)

export default component.exports